import { useState } from 'react';
import { Avatar } from '@metrodev/core-web';
import { useAuth } from '../../hooks/useAuth';
import { ProfileModal } from './ProfileModal';
import { useAvatarUrl } from './useAvatarUrl';

/** Foto (o iniciales) del usuario autenticado; al hacer clic abre su perfil para editarlo. */
export function UserAvatar({ size = 32 }: { size?: number }) {
  const user = useAuth((s) => s.user);
  const avatarUrl = useAvatarUrl();
  const [open, setOpen] = useState(false);
  const fullName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Mi perfil"
        aria-label="Abrir mi perfil"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', borderRadius: '50%', flexShrink: 0 }}
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt={fullName} style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover' }} />
        ) : (
          <Avatar name={fullName} size={size} />
        )}
      </button>
      {open && <ProfileModal onClose={() => setOpen(false)} />}
    </>
  );
}
